import { useMemo } from 'react';

import { selectDraft, selectInternalUsers } from '@/store/selectors/createSix';
import { setDraftField } from '@/store/slices/createSix/createSixSlice';
import { usePersonPicker } from '@/hooks/shared/usePersonPicker';

export function useStepOwners() {
  const { state, handlers } = usePersonPicker({
    selectDraft,
    selectUsers: selectInternalUsers,
    dispatchSetField: (dispatch, key, value) => dispatch(setDraftField({ key, value })),
    primaryKey: 'ownerIds',
    exclusionKey: 'internalParticipantIds',
  });

  const selectedOwners = useMemo(
    () => state.selected.map((person) => ({ ...person, isYou: false })),
    [state.selected]
  );

  return {
    state: {
      selectedOwners,
      candidateOwners: state.candidates,
      searchValue: state.searchValue,
    },
    handlers: {
      handleSearchValueChange: handlers.handleSearchChange,
      handleRemoveOwner: handlers.handleRemove,
      handleAddOwner: handlers.handleAdd,
    },
  };
}
